import { SENTRY_DSN } from 'astro:env/client';

export const getSentryDsn = () => (import.meta.env.PROD ? SENTRY_DSN : '');
